<template>
  <div class="pages-header">
    <search placeholder="请输入仓库/客户名称" @search="handleSearch"></search>
  </div>
</template>

<script>
import search from "./search.vue";
export default {
    components: {
        search
    },
    data(){
        return {

        }
    },
    methods: {
        handleSearch(value){
            this.$emit("search",value);
        }
    }
}
</script>

<style scoped lang="scss">
    .pages-header {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        z-index: 99;
        background-color: #FFF;
        padding: 0 12px;
        height: 52px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }
</style>